import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization} from "../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import {connect} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../config/design/TableIcons";
import {withRouter,Link} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import {TableCount, TablePage} from "../../../config/Permissions";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../config/Translate";
import AppCardLoaderTable from "../../components/Skeletons/AppCardLoaderTable";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {currencySymbol, price, truncate} from "../../../config/values";
import ModifyPriceButton from "./components/ModifyPriceButton";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import Alert from "@material-ui/lab/Alert/Alert";
import Button from "@material-ui/core/Button/Button";
import {getLimitUsage, hasProductLimit, UserHasLimit} from "../../../config/Security";
import AddBox from "@material-ui/icons/AddBox";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Grid from "@material-ui/core/Grid";
import SubTitleLight from "../../components/elements/SubTitleLight";
import FieldCounterTotal from "../../components/elements/FieldCounterTotal";
import ExcelImportButton from "../products/components/ExcelImportButton";

class ModifyPricing extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        columns: [
            {
                field: 'thumbnail',
                editable: 'never',
                filtering: false,
                title: Translate.thumbnail,
                render: rowData =>
                    <a href={`${defaultVariabls.website}/product/${rowData.slug}`} target="_blank" style={{position:"relative",display:"block"}}>
                        <img alt="avatar" src={rowData.thumbnail} className={this.classes.FMThumbnail}/>

                        {
                            rowData.situation === "worked" &&
                            <div style={{position:"absolute",bottom:0,padding:2,textAlign:"center",right:0,width:50,backgroundColor:"#232f3e",borderRadius:"0 0 4px 4px"}}>
                                <span style={{color:"#fff",fontSize:9,whiteSpace:"nowrap"}}>{Translate.worked}</span>
                            </div>
                        }
                    </a>
            },
            {
                title: Translate.productName,
                field: 'name',
                editable: 'never',
                filterPlaceholder: Translate.search,
                render: rowData =>
                    <>
                        <Typography>
                            <a className={this.classes.link} href={`${defaultVariabls.website}/product/${rowData.slug}`} target="_blank">
                                {
                                    !!rowData.value_id  ?
                                        rowData.name+" ("+rowData.value.attribute.name+" "+ (rowData.value.attribute.type === "color" ? rowData.value.description : rowData.value.name) +") " :
                                        rowData.name
                                }
                            </a>
                        </Typography>
                        <Typography style={{fontSize:12,marginTop:5}}>{rowData.shop.name}</Typography>
                    </>
            },
/*            {
                title: Translate.user,
                field: 'owner',
                editable: 'never',
                filterPlaceholder: Translate.search,
                hidden: !this.props.manage,
                render: rowData =>
                    rowData.owner.first_name+" "+rowData.owner.last_name
            },*/
            { title: Translate.price,
                field: 'price',
                filterPlaceholder: Translate.search,
                render: rowData =>
                    price(rowData.price)+" "+currencySymbol
            },
            { title: Translate.discount_price,
                field: 'discount_price',
                filterPlaceholder: Translate.search,
                render: rowData =>
                    <>
                        {
                            !!rowData.discount_price ?
                                price(rowData.discount_price)+" "+currencySymbol
                                : ''
                        }
                    </>

            },
            { title: Translate.inventory,
                field: 'inventory',
                filterPlaceholder: Translate.search,
                render: rowData =>
                    <>
                        {
                            rowData.inventory > 0 ?
                                rowData.inventory < 5 ?
                                    <Typography style={{color:"#ed701d"}}>
                                        {rowData.inventory}
                                    </Typography> :
                                    <Typography>
                                        {rowData.inventory}
                                    </Typography>
                                : rowData.status === "soon" ?
                                    <Typography style={{color:"#135d7f"}} className="date_in_table">
                                        {Translate.soon_pricing}
                                    </Typography>
                                        :
                                    <Typography style={{color:"#7f1313"}} className="date_in_table">
                                        {Translate.sold_pricing}
                                    </Typography>
                        }
                    </>
            },
/*            { title: Translate.confirmationStatus,
                editable: this.props.manage ? "onUpdate" : 'never',
                field: 'confirmed',
                filterPlaceholder: Translate.choose,
                lookup: {
                    1 :
                        <Typography style={{color: "#38bf84"}}>{Translate.confirmed}</Typography>
                    , 0:
                        <Typography color="textSecondary">{Translate.unConfirmed}</Typography>
                },
            },*/
            {
                title: Translate.lastUpdate,
                editable: 'never',
                field: 'updated_at',
                render: rowData =>
                    <Typography className="date_in_table">
                        {`${moment(rowData.updated_at).locale('fa').fromNow()}`}
                        <br/>
                        {`${moment(rowData.updated_at).locale('fa').format( 'HH:mm , YYYY/M/D')}`}
                    </Typography>
            },

            { title: Translate.activity,
                editable: 'never',
                field: 'activity',
                render: rowData =>
                    <ModifyPriceButton manage={this.props.manage} id={rowData.id} reload={() => this.loadData()}/>
            },
        ],
        data: [],
        loading:false,
        ChangeLoader:false,
        tab_index:!!this.props.match.params.type ? this.props.match.params.type : "all",

    };
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    handleTabs = async (event, newValue)=>
    {
        this.props.history.push(`/manage/pricing/${newValue}`);
        await this.setState({
            tab_index:newValue
        })
        await this.loadData()
    }
    onDelete(pricing_id){
        let data = new FormData();
        data.append('pricing_id',  pricing_id);
        this.setState({
            loading: false
        });
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/pricing/delete`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.deleteData, {
                    variant: 'success',
                });
                return true
            })
            .catch(error => {
                console.log(error.response);
                this.loadData();
                this.props.enqueueSnackbar(Translate.deleteDataFailed, {
                    variant: 'error',
                });

                return false
            });
    }
    onEdit(result) {
        let data = new FormData();
        data.append('id', result.id);
        data.append('price', result.price);
        data.append('discount_price', result.discount_price);
        data.append('inventory', result.inventory);
        data.append('confirmed', result.confirmed);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/pricing/edit`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.productEdited, {
                    variant: 'success',
                });
                return true
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.productEditingFailed, {
                    variant: 'error',
                });
                this.loadData();
                return false
            });
    }
    render(){
        let {manage} = this.props;
        let {tab_index} = this.state;
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderTable/> :
                        <Container maxWidth="xl">
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Alert severity="info">
                                        {Translate.pricingEditHelp}
                                    </Alert>
                                </Grid>
                             {/*   {
                                    this.props.manage &&
                                    <Grid item xs={12}>
                                        <Tabs
                                            value={tab_index}
                                            onChange={this.handleTabs.bind(this)}
                                            indicatorColor="primary"
                                            textColor="primary"
                                            centered
                                            variant={this.props.width === "xs" ? "scrollable" : ""}
                                            scrollButtons="auto"
                                        >
                                            <Tab value="all" label={Translate.all_pricings} />
                                            <Tab value="confirmed" label={Translate.confirmed_pricings} />
                                            <Tab value="unconfirmed" label={Translate.unconfirmed_pricings} />
                                        </Tabs>
                                    </Grid>
                                }*/}
                                <Grid item xs={12} lg={(!!hasProductLimit()) ? 6 : 12}>
                                    <ExcelImportButton reload={() => this.loadData()}/>
                                </Grid>
                                {
                                    (!!hasProductLimit()) &&
                                    <Grid item xs={12} lg={6}>
                                        <SubTitleLight align="left">
                                            {Translate.productLimit}
                                            <Button
                                                style={{float:"left"}}
                                                size="small"
                                                color="primary"
                                                variant="outlined"
                                                component={Link}
                                                to={'/buy-package'}
                                            >
                                                {Translate.buyPackage}
                                            </Button>
                                        </SubTitleLight>
                                        <FieldCounterTotal length={getLimitUsage()} max={hasProductLimit()}/>
                                    </Grid>
                                }
                                <Grid item xs={12}>
                                    <MaterialTable
                                        tableRef={this.tableRef}
                                        icons={tableIcons}
                                        title={
                                            <>
                                                {
                                                    this.props.width !== "xs" ?
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            style={{
                                                                borderColor: "#007185 !important",
                                                                backgroundColor:"#EDFDFF",
                                                                color:"#444",
                                                                border: "3px solid"
                                                            }}
                                                            component={Link}
                                                            to='/create/product'
                                                            disabled={!!hasProductLimit() && !UserHasLimit()}
                                                            startIcon={<AddBox />}
                                                        >
                                                            {Translate.makeProduct}
                                                        </Button> :
                                                        <IconButton color="primary"
                                                                    component={Link}
                                                                    to='/create/product'
                                                                    disabled={!!hasProductLimit() && !UserHasLimit()}
                                                        >
                                                            <AddBox />
                                                        </IconButton>
                                                }
                                            </>
                                        }
                                        localization={DataTableLocalization}
                                        columns={this.state.columns}
                                        data={query =>
                                            new Promise((resolve, reject) => {
                                                axios.get(`${defaultVariabls.url}/pricing/quickView/${manage?"yes":"no"}?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}&type=${tab_index}`, config)
                                                    .then(response => {
                                                        console.log(manage);
                                                        let data = [];
                                                        // eslint-disable-next-line
                                                        response.data.data.map((row) => {
                                                            data.push({
                                                                thumbnail:`${defaultVariabls.uploads}/FileManager/${row.product.thumbnail.name}_small.${row.product.thumbnail.extension}`,
                                                                name: truncate(row.product.name,17),
                                                                shop: row.shop,
                                                                slug: row.product.slug,
                                                                situation: row.product.situation,
                                                                owner: row.owner,
                                                                price: row.price,
                                                                discount_price: row.discount_price,
                                                                status: row.status,
                                                                inventory: row.inventory,
                                                                id: row.id,
                                                                confirmed: row.confirmed,
                                                                updated_at:row.updated_at
                                                            })
                                                        });
                                                        resolve({
                                                            data: data,
                                                            page: response.data.current_page - 1,
                                                            totalCount: response.data.total,
                                                        })
                                                    }).catch(error => {
                                                    console.log(error.response)
                                                })
                                            })
                                        }
                                        options={{
                                            pageSize: TablePage,
                                            pageSizeOptions: TableCount,
                                        }}
                                        editable={{
                                            onRowUpdate: async (newData, oldData) =>
                                                new Promise(resolve => {
                                                    setTimeout(() => {
                                                        resolve();
                                                        this.onEdit(newData);
                                                        if (oldData) {
                                                            this.setState(prevState => {
                                                                const data = [...prevState.data];
                                                                data[data.indexOf(oldData)] = newData;
                                                                return {...prevState, data};
                                                            });
                                                        }
                                                    }, 600);
                                                }),
                                            onRowDelete: oldData =>
                                                new Promise(resolve => {
                                                    setTimeout(() => {
                                                        resolve();
                                                        this.onDelete(oldData.id);
                                                        this.setState(prevState => {
                                                            const data = [...prevState.data];
                                                            data.splice(data.indexOf(oldData), 1);
                                                            return { ...prevState, data };
                                                        });
                                                    }, 600);
                                                }),
                                        }}
                                    />
                                </Grid>
                            </Grid>

                        </Container>
                }
            </>
        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(ModifyPricing)))));